import React, {useState} from "react";
import leftArrow from "../../../../assets/images/left-arrow.svg";
import "../style.css";
import {ListenerStatusInfo, ListenerStatusType} from "../../constant/Status.type";
import {LECTURE} from "../../../../constants/Routes";
import {useNavigate, useLocation} from "react-router";

export default function Search(
    props: {
        setListenerStatusType: (statusType: ListenerStatusType[]) => void;
        setKeyword: (keywords: string) => void;
        setPage: (page: number) => void;
    }
) {
    const navigate = useNavigate();
    const location = useLocation();
    const [statusTypes, setStatusTypes] = useState<ListenerStatusType[]>([]);
    const [keyword, setKeyword] = useState<string>("");

    const onKeywordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setKeyword(event.target.value);
    }

    const onCheckBoxChanged = (event: React.ChangeEvent<HTMLInputElement>, statusType: ListenerStatusType) => {
        setStatusTypes(statusTypes => {
            if (statusTypes.includes(statusType)) {
                return statusTypes.filter(type => type !== statusType);
            } else {
                return [...statusTypes, statusType];
            }
        })
    }

    const onSearchButtonClick = () => {
        if (statusTypes.length === 0 || statusTypes.length === 3) {
            props.setListenerStatusType([]);
        } else {
            props.setListenerStatusType(statusTypes);
        }

        props.setKeyword(keyword);
        props.setPage(0);
    }

    return (
        <section className="list-search-section">
            <div className="title-wrapper">
                <button onClick={() => navigate(LECTURE)}>
                    <img src={leftArrow} alt="left-arrow"/>
                </button>
                <div className="title" data-testid="title">
                    {location.state.title}
                </div>
            </div>

            <div className="list-search-wrapper">
                <div className="filter-section">
                    <div className="filter-state-wrapper">
                        <div className="filter-title">
                            상태
                        </div>
                        <div className="filter-state-content">
                            {
                                ListenerStatusInfo.statusTypes.map((status, index) => {
                                    return (
                                        <div className="filter-check" key={index}>
                                            <input
                                                type="checkbox"
                                                onChange={e => onCheckBoxChanged(e, index)}
                                                data-testid="checkbox"/>
                                            <div className="text">
                                                {status}
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                    <div className="filter-search-wrapper">
                        <div className="filter-title">
                            검색
                        </div>
                        <div className="filter-search-content">
                            <input className="search-input" placeholder="검색어 입력" type="text" onChange={onKeywordChange}/>
                        </div>
                    </div>

                </div>
                <button className="search-button" onClick={onSearchButtonClick}>
                    검색
                </button>
            </div>
        </section>
    )
}